const Hero = () => {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/bb3bb7efc0d93eaa724ecf93e9be2d53.jpg"
          alt="Vista aérea de São Paulo"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 flex flex-col items-start justify-center min-h-screen pt-24 pb-16">

        {/* Headline */}
        <h1 className="text-5xl md:text-7xl font-black text-white leading-tight mb-6 max-w-3xl">
          Imagens Aéreas<br />
          <span className="text-[#f5a623]">que Transformam</span><br />
          Seu Negócio
        </h1>

        {/* Subheadline */}
        <p className="text-white/70 text-lg md:text-xl max-w-xl mb-10 leading-relaxed font-light">
          Captamos perspectivas únicas para obras, imobiliárias, eventos e mapeamento. Tecnologia de ponta, resultados que impressionam.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="https://wa.me/5511954283481?text=Ol%C3%A1%2C%20tenho%20interesse%20nos%20servi%C3%A7os%20de%20drone"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold text-base px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-green-900/30"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Falar no WhatsApp
          </a>
          <button
            onClick={() => handleScroll('#servicos')}
            className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-semibold text-base px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            Ver Serviços
            <i className="ri-arrow-down-line text-lg"></i>
          </button>
        </div>

        {/* Stats */}
        <div className="flex flex-wrap gap-8 mt-16 pt-8 border-t border-white/20">
          {[
            { value: 'Grande SP', label: 'Atendemos toda SP' },
            { value: 'DJI Pro', label: 'Equipamentos de Qualidade' },
            { value: '100%', label: 'Clientes Satisfeitos' },
            { value: 'ANAC', label: 'Certificado' },
          ].map((stat) => (
            <div key={stat.label} className="flex flex-col">
              <span className="text-[#f5a623] text-2xl font-black">{stat.value}</span>
              <span className="text-white/60 text-sm font-light">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/40 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-s-line text-white/40 text-xl"></i>
      </div>
    </section>
  );
};

export default Hero;
